import styled from 'styled-components';

import { loadingGif } from '../assets/images';

const Loading = styled.div`
  width: 100%;
  height: 130px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;
export const LoadingContainer = () => {
  return (
    <Loading>
      <img src={loadingGif} alt="Loading" />
    </Loading>
  );
};
